import { enGB } from "date-fns/locale";
import React from "react";
import DateTimePicker, { registerLocale } from "react-datepicker";
import { DATE_FORMAT } from "util/date";
import { Nullable } from "util/extendedTypes";
import { addValidation, TValidateProp } from "validation/ValidationWrapper";
import { Tooltip } from "./Tooltip";
import { Input } from "reactstrap";

registerLocale("en-GB", enGB);
export type DatePickerProps = {
  selectedDate: Nullable<Date>;
  dateFormat?: string;
  disabled?: boolean;
  onChange: (date: Date) => void;
  onChangeRaw?(event: React.FocusEvent<HTMLInputElement>): void;
  onCalendarClose?: () => void;
  onBlur?: () => void;
  onFocus?: () => void;
  yearsDropdown?: boolean;
  showMonthYearPicker?: boolean;
  range?: [Nullable<Date>, Nullable<Date>];
  id: string;
  name: string;
  tooltipText?: string;
  label?: string;
};

export const DatePicker = (props: DatePickerProps) => {
  const [minDate, maxDate] = props.range || [];
  return (
    <>
      {(props.tooltipText || props.label) && (
        <label
          htmlFor={props.id}
          className={`inputField-header ${
            props.tooltipText && !props.label ? "inputField-header-end" : ""
          }`}
        >
          {props.label && <div className="inputField-label">{props.label}</div>}
          {props.tooltipText && (
            <Tooltip id={`${props.id}-tooltip`} text={props.tooltipText} />
          )}
        </label>
      )}

      <DateTimePicker
        id={props.id}
        name={props.name}
        showPopperArrow={false}
        popperPlacement="top-end"
        selected={props.selectedDate}
        onCalendarClose={props.onBlur}
        onChangeRaw={props.onChangeRaw}
        onChange={props.onChange}
        onBlur={props.onBlur}
        onFocus={props.onFocus}
        dateFormat={props.dateFormat || DATE_FORMAT}
        locale="en-GB"
        disabled={props.disabled}
        customInput={<Input className="inputField" />}
        showYearDropdown={props.yearsDropdown}
        showMonthYearPicker={props.showMonthYearPicker}
        minDate={minDate}
        maxDate={maxDate}
        placeholderText={(props.dateFormat || DATE_FORMAT).toUpperCase()}
      />
    </>
  );
};

const ValidDatePicker = addValidation<DatePickerProps, Nullable<Date>>(
  (p) => p.selectedDate
)(DatePicker);

const ValidDatePickerWrapper = (
  p: TValidateProp<DatePickerProps, Nullable<Date>>
) => (
  <div className="valid-date-picker">
    <ValidDatePicker {...p} />
  </div>
);

export { ValidDatePickerWrapper as ValidDatePicker };
